import { toast } from 'react-toastify';

// Toast configuration
const toastConfig = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

// Success toast
export const showSuccess = (message, options = {}) => {
    return toast.success(message, { ...toastConfig, ...options });
};

// Error toast
export const showError = (message, options = {}) => {
    return toast.error(message, { ...toastConfig, ...options });
};

// Info toast
export const showInfo = (message, options = {}) => {
    return toast.info(message, { ...toastConfig, ...options });
};

// Warning toast
export const showWarning = (message, options = {}) => {
    return toast.warning(message, { ...toastConfig, ...options });
};

// API error handler
export const showApiError = (error, defaultMessage = 'An error occurred') => {
    const message = error?.response?.data?.message || error?.message || defaultMessage;
    return showError(message);
};

// Success with custom duration
export const showSuccessQuick = (message) => {
    return showSuccess(message, { autoClose: 2000 });
};

// Error with longer duration
export const showErrorLong = (message) => {
    return showError(message, { autoClose: 8000 });
};

export default {
    showSuccess,
    showError,
    showInfo,
    showWarning,
    showApiError,
    showSuccessQuick,
    showErrorLong,
}; 